module.exports = __webpack_public_path__ + "static/media/php.4c1f239b.png";